import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import { RedesignFooter, RedesignHeader, RedesignPage } from './RedesignShell';

const taskItems = [
  'создать современный сайт ресторана под ключ',
  'реализовать онлайн-меню и удобную структуру',
  'внедрить систему онлайн-бронирования',
  'подготовить сайт под SEO-продвижение',
  'запустить рекламу и получать заявки',
];

const solutionBlocks = [
  {
    title: 'Разработка сайта ресторана с нуля',
    intro: 'Создан корпоративный сайт ресторана с продуманной структурой:',
    points: [
      'онлайн-меню с категориями и фильтрацией',
      'страницы с описанием кухни и концепции',
      'блоки с акциями и спецпредложениями',
      'форма онлайн-бронирования столиков',
      'фотогалерея и отзывы гостей',
      'адаптивная мобильная версия',
    ],
    note: 'Сайт сразу проектировался под поведение пользователей: быстрый доступ к меню и бронированию.',
  },
  {
    title: 'Разработка индивидуальной CMS для ресторана',
    intro: 'Разработана собственная CMS под задачи ресторана. Это позволило:',
    points: [
      'быстро обновлять меню и цены',
      'добавлять акции и события',
      'управлять бронированиями',
      'редактировать контент без разработчика',
    ],
    note: 'Клиент получил удобную систему управления, полностью адаптированную под ресторанный бизнес.',
  },
  {
    title: 'SEO-оптимизация сайта ресторана',
    intro: 'SEO выполнялось на этапе разработки сайта:',
    points: [
      'сбор семантического ядра (запросы: ресторан Сокольники, где поесть Москва и др.)',
      'формирование структуры страниц',
      'оптимизация мета-тегов и текстов',
      'настройка технического SEO',
      'оптимизация скорости загрузки',
    ],
    note: 'Это позволило сайту начать привлекать органический трафик сразу после запуска.',
  },
  {
    title: 'Запуск и продвижение',
    intro: 'После запуска сайта началась работа с привлечением клиентов:',
    points: ['SEO-продвижение сайта ресторана', 'подключение аналитики', 'запуск рекламы в Яндекс.Директ', 'работа с локальным трафиком'],
    note: 'Реклама дала быстрый поток бронирований уже в первый месяц.',
  },
];

const resultCards = [
  {
    title: 'SEO и органический трафик',
    points: [
      'рост позиций по локальным запросам (банкет в Сокольниках, банкет в Москве, ресторан в Москве - ТОП-1)',
      'увеличение органического трафика в 3 раза',
    ],
  },
  {
    title: 'Контекстная реклама',
    points: [
      'стабильный поток целевых посетителей',
      'оптимизированная стоимость клика ( 111 рублей/клик)',
      'увеличение количества бронирований на банкеты',
    ],
  },
  {
    title: 'Конверсии и заявки',
    points: [
      'рост онлайн-бронирований',
      'увеличение количества гостей',
      'сайт стал основным каналом привлечения клиентов',
    ],
  },
];

const clientGains = [
  'корпоративный сайт ресторана под ключ',
  'индивидуальную CMS',
  'SEO-оптимизированную структуру',
  'настроенную рекламу',
  'систему привлечения клиентов',
];

function SokolnikiRestaurantCasePage() {
  return (
    <RedesignPage>
      {/* TODO(brand-redesign): получить утверждённые Title и Description; текущие provisional-значения не подтверждены исходным ТЗ. */}
      <PageMeta
        title="Разработка корпоративного сайта ресторана в Сокольниках | Кейс Fatality"
        description="Кейс Fatality: корпоративный сайт ресторана в Сокольниках под ключ, индивидуальная CMS, SEO-оптимизация, реклама и рост бронирований."
      />
      <RedesignHeader />

      <section className="ink case-detail-hero">
        <div
          className="glow"
          style={{ right: '-340px', top: '-320px', width: '940px', height: '940px', opacity: 0.1 }}
        />
        <div className="container">
          <h1>Разработка корпоративного сайта ресторана в Сокольниках под ключ</h1>
          <p className="hero-sub">
            Разработка корпоративного сайта ресторана в районе Сокольники в
            Москве под ключ.
          </p>
          <p className="hero-sub">
            Проект включал полный цикл: создание сайта ресторана с нуля,
            разработку индивидуальной CMS, SEO-оптимизацию и запуск рекламы.
          </p>
          <p className="hero-sub">
            Результат: рост трафика, увеличение бронирований и стабильный поток
            заявок через сайт.
          </p>
          <img className="case-cover-image" src="/images/cases/elite.webp" srcSet="/images/cases/elite-840.webp 840w, /images/cases/elite-1280.webp 1280w, /images/cases/elite.webp 1672w" sizes="(max-width: 768px) calc(100vw - 40px), (max-width: 1024px) calc(100vw - 96px), 1184px" alt="Кейс ресторана Elite — сайт, SEO и Яндекс Карты" width="1672" height="941" decoding="async" />
        </div>
      </section>

      <section className="canvas sec-pad">
        <div className="container case-two-col">
          <div>
            <h2 className="standalone-h2">Задача проекта</h2>
          </div>
          <div className="case-rich-text">
            <p>
              Клиент — ресторан в Сокольниках — обратился за разработкой
              корпоративного сайта.
            </p>
            <p>Основные задачи:</p>
            <ul>
              {taskItems.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>
              Важно: нужен был не просто сайт ресторана, а инструмент для
              привлечения гостей и увеличения бронирований (особенно банкетов).
            </p>
          </div>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container">
          <div className="sec-head ink-head">
            <div>
              <h2>Решение</h2>
            </div>
            <p className="sub">
              Проект реализован с учетом особенностей ресторанного бизнеса и
              локального спроса в Москве.
            </p>
          </div>
          <div className="solution-grid">
            {solutionBlocks.map((block) => (
              <article className="solution-card" key={block.title}>
                <h3>{block.title}</h3>
                <p>{block.intro}</p>
                <ul>
                  {block.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
                <p>{block.note}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container">
          <div className="sec-head">
            <div>
              <h2>Результаты проекта</h2>
            </div>
            <p className="sub">
              Проект показал рост по ключевым бизнес-показателям ресторана.
            </p>
          </div>
          <div className="result-grid">
            {resultCards.map((result) => (
              <div className="compact-card" key={result.title}>
                <h3>{result.title}</h3>
                <ul className="source-list">
                  {result.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <p className="service-hero-copy" style={{ color: '#141619' }}>
            В результате ресторан начал получать стабильный поток клиентов через сайт.
          </p>
        </div>
      </section>

      <section className="ink sec-pad">
        <div className="container case-two-col">
          <div>
            <h2 className="standalone-h2 light">Что получил клиент</h2>
          </div>
          <div className="case-rich-text dark">
            <p>
              В рамках проекта клиент получил не просто разработку сайта, а готовое решение для бизнеса:
            </p>
            <ul>
              {clientGains.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <p>Сайт стал основным инструментом маркетинга ресторана.</p>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad section-line-top">
        <div className="container case-two-col">
          <div>
            <h2 className="standalone-h2">Почему этот кейс важен</h2>
          </div>
          <div className="case-rich-text">
            <p>Этот проект показывает, что разработка сайта ресторана — это не только дизайн.</p>
            <p>Ключевую роль играет комплексный подход:</p>
            <ul>
              <li>разработка сайта</li>
              <li>SEO-оптимизация</li>
              <li>реклама</li>
              <li>аналитика</li>
            </ul>
            <p>Только в таком формате сайт начинает приносить реальный результат и окупаться.</p>
          </div>
        </div>
      </section>

      <section className="ink lead" id="restaurant-case-lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <h2 className="lead-heading">Хотите такой же результат?</h2>
              <p className="lead-text">
                Разработка корпоративного сайта ресторана — это инвестиция в поток гостей и рост бизнеса.
              </p>
              <p className="lead-text">
                Оставьте заявку — разберем ваш проект, покажем точки роста и рассчитаем стоимость разработки сайта.
              </p>
            </div>
            <LeadForm
              formId="restaurant-case-lead-form"
              idPrefix="restaurant-case"
              eyebrow="Форма заявки"
            />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default SokolnikiRestaurantCasePage;
